import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { InsuranceCompany, InsuranceCompanyBranch } from '../../model/insurance/InsuranceCompany';
import { CareNetAPIResponse } from '../../model/shared/model';
import { tap, map, delay } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EnvService } from '../../shared/environment-service/env.service';

@Injectable({
  providedIn: 'root'
})
export class InsuranceService {

  constructor(private http: HttpClient, public env: EnvService) { }

  GetInsuranceCompanies(username): Observable<InsuranceCompany[]> {
    const url = this.env.Environment.carenetApiUrl + 'api/Insurance/GetInsuranceCompaniesForReferral?username=' + username;
    return this.http.get<CareNetAPIResponse<InsuranceCompany[]>>(url, { responseType: 'json' }).pipe(map(data => data.data));
  }

  GetInsuranceCompaniesBranch(insuranceCompanyId): Observable<InsuranceCompanyBranch[]> {

    const url = this.env.Environment.carenetApiUrl + 'api/LabReferral/GetInsuranceCompaniesBranch?insuranceCompanyId=' + insuranceCompanyId;
    return this.http.get<CareNetAPIResponse<InsuranceCompanyBranch[]>>(url, { responseType: 'json' }).pipe(map(data => data.data));
  }
}
